module.exports = __webpack_public_path__ + "img/sanpablo.423bdfff.jpg";